import request from "@/utils/request";

export default function agentBindCardForWeChat(card) {
    return request({
        url: `/user/card/agentCancelsCardLossReporting/${card}`,
        method: 'post',
    })
}
